export default __webpack_public_path__ + "static/m-hnh1-44734a10dec915bbb1982507692acc24.jpg";